import React, { useEffect, useState } from 'react'
import Header from '../../Layout/Header';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';


export default function About() {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % 5);
        }, 3000);

        return () => clearInterval(timer);
    }, []);

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScroll(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scale = 1 + scroll / 500;
    const maxScale = 2;

    const videoStyle = {
        position: 'fixed',
        zIndex: '-1',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%) scale(${Math.min(scale, maxScale)})`,
        width: '100%',
        height: '100%',
    };
    return (
        <div className='text-white'>
            <div className='video-content'>
                <video
                    className='absolute inset-0 object-cover object-center w-full h-full scale-110'
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={videoStyle}
                >
                    <source src='/assets/bg/bg.mp4' type='video/mp4' />
                </video>
                <div className='absolute inset-0 bg-[#0E081B]/30'></div>
            </div>
            <div className='content'>
                <div className='about-sec-1 flex flex-col lg:h-screen'>
                    <Header />
                    <div className='flex flex-1 items-center justify-center relative'>
                        <Section1/>
                    </div>
                </div>
                <div>
                    <Section2/>
                    <Section3 />
                </div>
            </div>
        </div>
    )
}
